namespace GeniuzPOS.Inventory {
    export class IcStockReturnOutColumns {
        static columnsKey = 'Inventory.IcStockReturnOut';
    }
}
